import { render, staticRenderFns } from "./OpenShiftCard.vue?vue&type=template&id=0179b2ca&"
import script from "./OpenShiftCard.vue?vue&type=script&lang=js&"
export * from "./OpenShiftCard.vue?vue&type=script&lang=js&"
import style0 from "./OpenShiftCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VChip,VList,VListItem,VListItemContent,VListItemGroup})
